module.exports = __webpack_public_path__ + "static/media/icon_denkyuu.0876036b.svg";